export default __webpack_public_path__ + "43138d18dc9677cb37d9e1d21599fa1c.svg";